import { useEffect, useState } from "react";
import axios from "axios";
import { Input } from "@/components/ui/input";
import { History, Search } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const BEREICHE = { teilnehmer: "Teilnehmer", rechnung: "Rechnung", pflegeeinrichtung: "Pflegeeinrichtung", aufgabe: "Aufgabe",
  kontaktprotokoll: "Kontaktprotokoll", email: "E-Mail" };
const AKTIONEN = { erstellt: "angelegt", aktualisiert: "geändert", "gelöscht": "gelöscht", gesendet: "gesendet", storniert: "storniert" };

const ohneEmoji = (s) => String(s || "").replace(/[\u{1F300}-\u{1FAFF}\u{2600}-\u{27BF}]\uFE0F?\s?/gu, "");
const zeit = (s) => (s ? new Date(s).toLocaleString("de-DE", { dateStyle: "short", timeStyle: "short" }) : "");

export const satz = (a) => {
  const was = BEREICHE[a.bereich] || a.bereich || "Eintrag";
  const name = a.bereich_name || a.teilnehmer_name || a.pflegeeinrichtung_name || "";
  const tat = AKTIONEN[a.aktion] || a.aktion || "";
  return `${was}${name ? ` „${name}“` : ""} ${tat}`.trim();
};

export const ProtokollZeile = ({ a }) => (
  <li className="py-3 flex gap-4" data-testid={`protokoll-${a.id}`}>
    <span className="text-xs text-stone-500 w-28 shrink-0 pt-0.5">{zeit(a.datum || a.created_at)}</span>
    <div className="min-w-0">
      <p className="text-sm text-stone-900"><b>{a.benutzer && a.benutzer !== "None" ? a.benutzer : "System / nicht erfasst"}</b> · {satz(a)}</p>
      {(a.details || a.beschreibung) && <p className="text-xs text-stone-600 mt-0.5 break-words">{ohneEmoji(a.details || a.beschreibung)}</p>}
    </div>
  </li>
);

export default function Aenderungsprotokoll() {
  const [liste, setListe] = useState([]);
  const [f, setF] = useState({ suche: "", bereich: "", von: "", bis: "" });
  useEffect(() => {
    const t = setTimeout(() => axios.get(`${API}/aenderungsprotokoll`, { params: f }).then((r) => setListe(r.data)).catch(() => setListe([])), 300);
    return () => clearTimeout(t);
  }, [f]);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  return (
    <div className="page-container" data-testid="aenderungsprotokoll-page">
      <h1 className="text-3xl font-semibold flex items-center gap-3" style={{ fontFamily: "Manrope, sans-serif" }}>
        <History className="h-7 w-7 text-[#D9775A]" /> Änderungsprotokoll
      </h1>
      <p className="text-sm text-stone-500 mt-1 mb-6">Wer hat wann was geändert – wird automatisch geschrieben und kann nicht bearbeitet werden.</p>
      <div className="flex flex-wrap gap-3 mb-4">
        <div className="relative flex-1 min-w-[220px]">
          <Search className="h-4 w-4 absolute left-3 top-3 text-stone-400" />
          <Input className="pl-9" placeholder="Teilnehmer, Rechnung, Person …" value={f.suche} onChange={set("suche")} data-testid="protokoll-suche" />
        </div>
        <select className="border rounded-md px-3 text-sm bg-white" value={f.bereich} onChange={set("bereich")} data-testid="protokoll-bereich">
          <option value="">Alle Bereiche</option>
          {Object.entries(BEREICHE).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
        </select>
        <Input type="date" className="w-40" value={f.von} onChange={set("von")} data-testid="protokoll-von" />
        <Input type="date" className="w-40" value={f.bis} onChange={set("bis")} data-testid="protokoll-bis" />
      </div>
      <p className="text-xs text-stone-500 mb-2" data-testid="protokoll-anzahl">{liste.length} Einträge</p>
      <ul className="divide-y divide-stone-200 bg-white rounded-xl border border-stone-200 px-4">
        {liste.map((a) => <ProtokollZeile key={a.id} a={a} />)}
        {!liste.length && <li className="py-8 text-center text-sm text-stone-500">Keine Einträge</li>}
      </ul>
    </div>
  );
}
